import { v4 } from 'uuid';

import { BoundToEdge } from '../../../component-classes';
import { ComponentItemData } from '../../../component-classes/data/component-item-data.class';
import { deepCopy } from '../../../helpers';
import { blueprintData6, blueprintKitchenData7 } from '../../defaults';
import { IslandDataOut, IslandType } from '../../../blueprint-classes';

type island6Type = typeof blueprintData6['state'][0]['islands'][0];
type state6Type = typeof blueprintData6['state'][0];
type panels7Type = typeof blueprintKitchenData7['design']['islands']['children'][0]['panels'];

export const updatePanels = (island: island6Type, tIsland: IslandDataOut, state: state6Type): panels7Type => {
	let panels: panels7Type['children'] = [];
	// console.log('updatePanels:island', tIsland);
	const panelMap = tIsland.type === IslandType.Corner
		? [0, 1, 4, 5]
		: [0, 1, 2, 3];

	panels = island.panels.map((panel, iPanel) => {
		return {
			...deepCopy(tIsland.panels.children[panelMap[iPanel]]),
			// id: panel.key,
			label: panel.name,
			countertopOverhang: island.countertop.overhangs[iPanel],
			size: {
				width: panel.xSize,
				height: panel.ySize,
				depth: panel.zSize
			},
			panelItemGroups: panel.panelItemGroups.map((panelItemGroup, iPanelItemGroup) => {
				return {
					id: panelItemGroup.key,
					center: {
						x: panelItemGroup.center.x - (island.size.x / 2),
						y: 0,
						z: 0
					},
					items: panelItemGroup.items.map((item) => {
						return {
							id: item.key,
							boundToEdge: BoundToEdge.No,
							diemnsionOffsets: {
								...item.dimensionOffsets,
								zLine: item.dimensionOffsets.hLine,
								zLabel: item.dimensionOffsets.hLabel
							},
							item: {
								id: ComponentItemData.getDataBySku(item.item.sku).id ?? null
							},
							center: {
								x: 0,
								y: item.center.y - (island.size.y / 2),
								z: item.center.z - (island.size.z / 2)
							}
						};
					})
				};
			})
		}
	});

	return {
		frontPanelId: panels[0].id,
		// frontPanelId: island.panels[0].key,
		children: panels,
		surroundMaterial: {
			key: state.material.surround,
			override: false
		}
	};
};
